'use client';

import React from 'react';
import Script from 'next/script';
import Caption from '../Caption/Caption';
import { InstagramEmbedPropTypes } from './InstagramEmbed.types';
export default function InstagramEmbed({
  data,
  className = ''
}: InstagramEmbedPropTypes) {
  const ref = React.useRef<HTMLQuoteElement>(null);
  React.useEffect(() => {
    if (typeof window !== 'undefined' && window.instgrm) {
      window.instgrm.Embeds.process();
    }
  }, [data?.embedUrl]);
  return <>
      <Script async src='https://www.instagram.com/embed.js' onLoad={() => window.instgrm?.Embeds.process()} data-sentry-element="Script" data-sentry-source-file="InstagramEmbed.tsx" />

      <figure className={`mx-auto ${className}`}>
        <blockquote ref={ref} className={`instagram-media mx-auto w-full !min-w-[calc(100vw-48px)] !max-w-[540px] sm:!min-w-[50rem] ${className}`} data-instgrm-permalink={data?.embedUrl} data-instgrm-version='14' data-instgrm-captioned='true' />

        {data?.bodyCopy && <Caption bodyCopy={data?.bodyCopy} />}
      </figure>
    </>;
}